<mat-dialog-content>
  <div>
    <span class="shortcut">
      <mat-icon class="shortcut-icon">keyboard_return</mat-icon
      >{{ 'igo.geo.draw.finish' | translate }}</span
    >
  </div>
  <div>
    <span class="shortcut">
      <mat-icon class="shortcut-icon">keyboard_backspace</mat-icon
      >{{ 'igo.geo.draw.undo' | translate }}</span
    >
  </div>
  <div>
    <span class="shortcut">
      <igo-icon [icon]="svgIcon" />
      {{ 'igo.geo.draw.abort' | translate }}
    </span>
  </div>
  <div>
    <span class="shortcut">
      <mat-icon class="shortcut-icon">space_bar</mat-icon
      >{{ 'igo.geo.draw.move' | translate }}</span
    >
  </div>
</mat-dialog-content>
<mat-dialog-actions class="shortcuts-close">
  <button matButton="elevated" mat-dialog-close color="primary">OK</button>
</mat-dialog-actions>
